const { useCallback, useRef, useState } = require('react');
const { prepareChatImageAttachmentFromEvent } = require('utils/imageUploadPresets');

const MB_IN_BYTES = 1024 * 1024;
const MAX_IMAGE_SIZE_MB = 10;

exports.useChatImageAttachment = function useChatImageAttachment({ showNotification }) {

    const [imagePreviewUrl, setImagePreviewUrl] = useState('');
    const [isConvertingImage, setIsConvertingImage] = useState(false);
    const [isUploadingImage, setIsUploadingImage] = useState(false);
    const [selectedImageFile, setSelectedImageFile] = useState(null);
    const imageInputRef = useRef(null);

    const resetSelectedImage = useCallback(() => {

        setSelectedImageFile(null);
        setImagePreviewUrl('');

        if (imageInputRef.current) {
            imageInputRef.current.value = null;
        }
    }, []);

    const choosePic = useCallback(async (evt) => {

        const result = await prepareChatImageAttachmentFromEvent(evt, {
            maxImageSizeMb: MAX_IMAGE_SIZE_MB,
            mbInBytes: MB_IN_BYTES,
            onStart: () => setIsConvertingImage(true),
            onComplete: () => setIsConvertingImage(false)
        });

        if (result.status === 'empty') {
            return;
        }

        if (result.status !== 'ready') {
            if (result.error) {
                console.error('Error processing image:', result.error);
            }

            showNotification(result.message);
            resetSelectedImage();
            return;
        }

        setImagePreviewUrl(result.previewUrl);
        setSelectedImageFile(result.file);
    }, [resetSelectedImage, showNotification]);

    return {
        choosePic,
        imageInputRef,
        imagePreviewUrl,
        isConvertingImage,
        isUploadingImage,
        resetSelectedImage,
        selectedImageFile,
        setIsUploadingImage
    };
};
